import {Injectable} from "@angular/core";
import {environment} from "@environments/environment";
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class OpenApiService {
    private baseUrl = environment.baseUrl;
    constructor(
        private http: HttpClient
    ) { }

    generateTokenApi(uuid: string): Observable<void> {
        const url = `${this.baseUrl}/back-office/v1/open/api/${uuid}`;
        return this.http.get<void>(url);
    }
    deleteTokenApi(uuid: string): Observable<void> {
        const url = `${this.baseUrl}/back-office/v1/open/api/${uuid}`;
        return this.http.delete<void>(url);
    }
}
